import React, { useState, useRef, useEffect } from 'react';
import { useAudioPlayer } from './AudioPlayerProvider';

const download = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = url.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

const DownloadSvg = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 12C17.5128 12 17.9355 12.386 17.9933 12.8834L18 13V15C18 16.5977 16.7511 17.9037 15.1763 17.9949L15 18H5C3.40232 18 2.09634 16.7511 2.00509 15.1763L2 15V13C2 12.4477 2.44772 12 3 12C3.51284 12 3.93551 12.386 3.99327 12.8834L4 13V15C4 15.5128 4.38604 15.9355 4.88338 15.9933L5 16H15C15.5128 16 15.9355 15.614 15.9933 15.1166L16 15V13C16 12.4477 16.4477 12 17 12ZM10 2C10.5523 2 11 2.44772 11 3V10.585L12.2929 9.29289C12.6534 8.93241 13.2206 8.90468 13.6129 9.2097L13.7071 9.29289C14.0676 9.65338 14.0953 10.2206 13.7903 10.6129L13.7071 10.7071L10.7071 13.7071C10.3466 14.0676 9.77939 14.0953 9.3871 13.7903L9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.65338 8.93241 7.22061 8.90468 7.6129 9.2097L7.70711 9.29289L9 10.585V3C9 2.44772 9.44772 2 10 2Z"
            fill="#353535"
        />
    </svg>
);

const OptionsSvg = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 19C15.1046 19 16 19.8954 16 21C16 22.1046 15.1046 23 14 23C12.8954 23 12 22.1046 12 21C12 19.8954 12.8954 19 14 19ZM14 12C15.1046 12 16 12.8954 16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12ZM16 7C16 5.89543 15.1046 5 14 5C12.8954 5 12 5.89543 12 7C12 8.10457 12.8954 9 14 9C15.1046 9 16 8.10457 16 7Z"
            fill="white"
        />
    </svg>
);

const PlaybackSpeedSvg = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9144 11.306C19.8001 12.1736 19.5725 13.0211 19.2388 13.8269L19.2412 13.8279C18.9041 14.6409 18.4628 15.3998 17.934 16.0879L17.9336 16.0876C17.8549 16.1901 17.774 16.2913 17.6911 16.3911C17.212 16.9677 16.6735 17.484 16.0875 17.9336L16.0878 17.934C15.3997 18.4628 14.6409 18.9041 13.8279 19.2412L13.8269 19.2388C13.0259 19.5706 12.179 19.7994 11.3059 19.9144L11.3061 19.9155C10.8786 19.9713 10.4427 20 10 20C9.55733 20 9.12138 19.9713 8.69391 19.9155L8.82325 18.9239L8.9526 17.9323C9.29452 17.9769 9.64406 18 9.99997 18C10.3257 18 10.6528 17.9801 10.9794 17.9398C13.0009 17.6905 14.8511 16.6794 16.1529 15.1129C17.4546 13.5464 18.1098 11.5423 17.9849 9.50937C17.86 7.4764 16.9644 5.56763 15.4806 4.17226C14.0291 2.8072 12.1217 2.03404 10.1326 2.0011C10.0885 2.00039 10.0443 2.00003 10 2.00003C9.64406 2.00003 9.29451 2.02315 8.9526 2.06775L8.82325 1.07615L8.69391 0.0845534C9.12137 0.0287943 9.55732 3.10546e-05 9.99999 3.05176e-05V3.8147e-06C10.0555 3.8147e-06 10.1109 0.000465188 10.1663 0.00138588C10.552 0.00767456 10.9323 0.0357909 11.3061 0.0845532L11.306 0.0856159C12.1753 0.200122 13.0227 0.42811 13.8269 0.761233L13.8279 0.758835C14.6409 1.09596 15.3997 1.53724 16.0878 2.06604L16.0876 2.0664C16.3516 2.26898 16.6063 2.48544 16.8508 2.71533C17.2458 3.08683 17.6075 3.48745 17.9336 3.91247L17.934 3.91219C18.4628 4.60031 18.9041 5.35918 19.2412 6.17215L19.2388 6.17315C19.5713 6.9758 19.7996 7.8229 19.9144 8.69408L19.9155 8.69394C19.9701 9.11306 19.9989 9.54033 20 9.9741C20 9.98274 20 9.99138 20 10C20 10.0179 20 10.0358 19.9999 10.0537M9.00334 6.13771L13.0018 9.13658C13.6242 9.49962 13.6608 10.3673 13.1117 10.7897L9.00334 13.8624C8.33693 14.2511 7.50003 13.7704 7.50003 12.9989V7.00116C7.50003 6.22966 8.33693 5.74897 9.00334 6.13771ZM6.55518 1.68256L6.17212 0.758836C5.35915 1.09596 4.60028 1.53725 3.91216 2.06604L4.52148 2.85896L5.13081 3.65188C5.68194 3.22836 6.28894 2.87554 6.93823 2.60629L6.55518 1.68256ZM2.85892 4.52152L2.06601 3.91219C1.53721 4.60031 1.09593 5.35918 0.758805 6.17215L1.68253 6.55521L2.60626 6.93826C2.87551 6.28897 3.22833 5.68197 3.65184 5.13084L2.85892 4.52152ZM0 10C0 9.55736 0.0287632 9.12141 0.0845227 8.69394L1.07612 8.82329L2.06772 8.95263C2.02312 9.29455 2 9.64409 2 10C2 10.356 2.02312 10.7055 2.06772 11.0474L1.07612 11.1768L0.0845229 11.3061C0.0287633 10.8787 0 10.4427 0 10ZM1.68253 13.4449L0.758806 13.8279C1.09593 14.6409 1.53722 15.3998 2.06601 16.0879L2.85893 15.4785L3.65184 14.8692C3.22833 14.3181 2.87551 13.7111 2.60626 13.0618L1.68253 13.4449ZM4.52149 17.1411L3.91216 17.934C4.60028 18.4628 5.35915 18.9041 6.17212 19.2412L6.55518 18.3175L6.93823 17.3938C6.28894 17.1245 5.68194 16.7717 5.13081 16.3482L4.52149 17.1411Z"
            fill="#353535"
        />
    </svg>
);

const MenuItem = ({ clickHandler, content }) => {
    return (
        <div
            className="menu-item-button"
            tabIndex={0}
            role="button"
            aria-label="options item"
            onClick={clickHandler}
            onKeyPress={clickHandler}
            style={{
                height: '36px',
                cursor: 'pointer',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    paddingLeft: '16px',
                    alignItems: 'center',
                    height: '36px',
                    fontSize: '14px',
                    lineHeight: '18px',
                }}
            >
                {content}
            </div>
        </div>
    );
};

const PopupMenu = ({ onClose, containerRef }) => {
    const { src, playbackRate, setPlaybackRate } = useAudioPlayer();

    const wrapperRef = useRef(null);
    const [playbackSpeedView, setPlaybackSpeedView] = useState(false);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    ref.current &&
                    !ref.current.contains(event.target) &&
                    containerRef.current &&
                    !containerRef.current.contains(event.target)
                ) {
                    onClose();
                }
            };
            // Bind the event listener
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    const defaultMenuItems = [
        {
            clickHandler: () => {
                download(src);
                onClose();
            },
            content: (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <div style={{ marginRight: '8px' }}>
                        <DownloadSvg />
                    </div>
                    Download
                </div>
            ),
            key: 'download',
        },
        {
            clickHandler: () => setPlaybackSpeedView(true),
            content: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: '8px' }}>
                        <PlaybackSpeedSvg />
                    </div>
                    Playback speed
                </div>
            ),
            key: 'playback',
        },
    ];

    const setSpeed = (speed) => {
        setPlaybackRate(speed);
    };

    const isContentBold = (content, speed) => {
        if (speed === playbackRate) {
            return <b>{content}</b>;
        }
        return content;
    };

    const playbackSpeedItems = [
        {
            clickHandler: () => setSpeed(0.5),
            content: isContentBold('0.5', 0.5),
            key: '05',
        },
        {
            clickHandler: () => setSpeed(0.75),
            content: isContentBold('0.75', 0.75),
            key: '075',
        },
        {
            clickHandler: () => setSpeed(1.0),
            content: isContentBold('Normal', 1.0),
            key: '10',
        },
        {
            clickHandler: () => setSpeed(1.25),
            content: isContentBold('1.25', 1.25),
            key: '125',
        },
        {
            clickHandler: () => setSpeed(1.5),
            content: isContentBold('1.5', 1.5),
            key: '15',
        },
        {
            clickHandler: () => setSpeed(2),
            content: isContentBold('2', 2),
            key: '2',
        },
    ];

    return (
        <div
            className="options-popup"
            style={{
                zIndex: '1',
                paddingTop: '8px',
                paddingBottom: '8px',
                width: '160px',
                position: 'absolute',
                backgroundColor: '#ffffff',
                borderRadius: '6px',
                boxShadow: '0px 4px 8px rgba(53, 53, 53, 0.2)',
            }}
            ref={wrapperRef}
        >
            {!playbackSpeedView
                ? defaultMenuItems.map((m) => (
                      <MenuItem
                          clickHandler={m.clickHandler}
                          content={m.content}
                          key={m.key}
                      />
                  ))
                : null}
            {playbackSpeedView
                ? playbackSpeedItems.map((m) => (
                      <MenuItem
                          clickHandler={m.clickHandler}
                          content={m.content}
                          key={m.key}
                      />
                  ))
                : null}
        </div>
    );
};

export const Options = () => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    const handleClick = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div style={{ position: 'absolute', right: '8px' }}>
            {isOpen ? (
                <PopupMenu
                    containerRef={containerRef}
                    onClose={() => setIsOpen(false)}
                />
            ) : null}
            <div
                className="options-button"
                role="button"
                aria-label="options"
                ref={containerRef}
                onClick={handleClick}
                tabIndex={0}
                onKeyPress={handleClick}
                style={{
                    position: 'relative',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '34px',
                }}
            >
                <div className="volume-options">
                    <OptionsSvg />
                </div>
            </div>
        </div>
    );
};
